// 系统外部程序页面
const external = [
  {
    // 用户直接修改短剧演员信息。 
    path: '/actorEditLogin',
    name: 'actorEditAuth',
    component: () => import('@/pages/external/actorAuthLogin.vue'),
    meta: {
      title: 'WETRUE',
      isLogin: false,
      isKeeplive: false,
      zIndex: 999
    },
  },{
      // 用户直接修改短剧演员信息。 
      path: '/actorEdit',
      name: 'actorEdit',
      component: () => import('@/pages/external/actorEdit.vue'),
      meta: {
        title: 'WETRUE',
        isLogin: false,
        isKeeplive: false,
        zIndex: 1000
      },
    },{
      // 用户直接修改短剧演员信息。 
      path: '/testDev',
      name: 'testDev',
      component: () => import('@/pages/external/testDev/index.vue'),
      meta: {
        title: 'WETRUE',
        isLogin: false,
        isKeeplive: false,
        zIndex: 999
      },
    },{
      // 用户直接修改短剧演员信息。 
      path: '/vtt',
      name: 'vtt',
      component: () => import('@/pages/external/videoToText.vue'),
      meta: {
        title: 'WETRUE',
        isLogin: false,
        isKeeplive: false,
        zIndex: 999
      },
    },
  ];
  export default external;
  


// WEBPACK FOOTER //
// ./src/router/external.js